import React, { useState, useRef } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { TopButs } from "./TopButs";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottom";
import { AddGoodsModal } from "./AddGoodsModal";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { MaterialHistoryModel } from "./materialHistoryModel"
import useNavModel, { RouterParamType } from "@/model/navModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

// const titleType = {
//     add: "新增",
//     edit: "编辑",
//     look: "查看",
// }
export const SaleSoDetails = () => {

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const titleType = {
        add: Locale["Add"],
        edit: Locale["Edit"],
        look: Locale["View"],
    }
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const IYhFormRef = useRef<IYhFormRef>();
    return (
        <>
            <YhPageHeader title={`${titleType[detailsInfo.mode]}${'  '}${Locale["Material Sales"]}`} />
            <TopButs {...detailsInfo} IYhFormRef={IYhFormRef} />
            <FormBox {...detailsInfo} IYhFormRef={IYhFormRef} />
            <TableBox {...detailsInfo} />
            <FixedBottom {...detailsInfo} />
            <AddGoodsModal {...detailsInfo} />
            <MaterialHistoryModel {...detailsInfo} />
        </>
    )
}